var _g, _rect, _path, _path2, _circle, _circle2, _circle3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "52.5 74 174 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 60,
    fill: "#F71111"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 59.5,
    stroke: "#CED3D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 143.4,
    width: 7.2,
    height: 7.2,
    rx: 1.6,
    stroke: "#38C5F2",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.355 90.7481L203.426 85.1697L204.721 94.0827L196.355 90.7481Z",
    stroke: "#EF24DB",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.152 186.543L188.223 180.965L189.518 189.878L181.152 186.543Z",
    stroke: "#73B024",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 134.5,
    r: 4.1,
    stroke: "#DAC507",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 204.5,
    r: 4.1,
    stroke: "#37B7FF",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 90.5,
    r: 4.1,
    stroke: "#FF9F2E",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 100.666C111.348 100.666 108.804 101.72 106.929 103.595C105.054 105.47 104 108.014 104 110.666V157.333C104 159.985 105.054 162.528 106.929 164.404C108.804 166.279 111.348 167.333 114 167.333H134C136.652 167.333 139.196 166.279 141.071 164.404C142.946 162.528 144 159.985 144 157.333V110.666C144 108.014 142.946 105.47 141.071 103.595C139.196 101.72 136.652 100.666 134 100.666H114ZM148.31 118.309C148.935 117.684 149.783 117.333 150.667 117.333C151.551 117.333 152.398 117.684 153.023 118.309L166.357 131.643C166.982 132.268 167.333 133.115 167.333 133.999C167.333 134.883 166.982 135.731 166.357 136.356L153.023 149.689C152.395 150.297 151.553 150.633 150.679 150.625C149.805 150.617 148.969 150.267 148.351 149.649C147.733 149.031 147.382 148.195 147.374 147.321C147.367 146.447 147.703 145.605 148.31 144.976L155.953 137.333H127.333C126.449 137.333 125.601 136.981 124.976 136.356C124.351 135.731 124 134.883 124 133.999C124 133.115 124.351 132.267 124.976 131.642C125.601 131.017 126.449 130.666 127.333 130.666H155.953L148.31 123.023C147.685 122.398 147.334 121.55 147.334 120.666C147.334 119.782 147.685 118.934 148.31 118.309Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2617_11793",
    x: 0,
    y: 0,
    width: 280,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.580392 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_11793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_11793",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.5b3dfec82d2ef34c5dcc5df04e61ecbe.svg";
export { ForwardRef as ReactComponent };